export const toggleColumns = [
  { id: 1, name: "Photo" },
  { id: 2, name: "Contact#" },
  { id: 3, name: "Name" },
  { id: 4, name: "Last Name" },
  { id: 5, name: "File#" },
  { id: 6, name: "House#" },
  { id: 7, name: "Date" },
  { id: 8, name: "File" },
  { id: 9, name: "Registry" },
  { id: 10, name: "Updated By" },
  { id: 11, name: "Size" },
  { id: 12, name: "Recieved" },
  { id: 13, name: "Balance" },
  { id: 14, name: "Others" },
  { id: 15, name: "Invoice" },
];

export const searchBorrowerPills = [
  { id: 1, title: "Customers", value: "950", variant: "dark" },
  { id: 1, title: "Total Marlay", value: "1,518", variant: "info" },
  { id: 1, title: "Price", value: "Rs. 1,405,861,300", variant: "dark" },
  { id: 1, title: "Received", value: "Rs. 221,331,860", variant: "info" },
  { id: 1, title: "Balance", value: "Rs. 1,184,529,440", variant: "dark" },
  { id: 1, title: "Others", value: "Rs. 61,100", variant: "info" },
  { id: 1, title: "Invoices", value: "6,022", variant: "dark" },
];

export const searchBorrowerTableColumns = [
  { id: 1, name: "Data 1" },
  { id: 2, name: "Data 2" },
  { id: 3, name: "Data 3" },
  { id: 4, name: "Data 4" },
  { id: 5, name: "Data 5" },
];

export const searchBorrowerTableRows = [
  {
    id: 1,
    col1: "Data 1",
    col2: "Data 2",
    col3: "Data 3",
    col4: "Data 4",
    col5: "Data 5",
  },
  {
    id: 2,
    col1: "Data 6",
    col2: "Data 7",
    col3: "Data 8",
    col4: "Data 9",
    col5: "Data 10",
  },
  {
    id: 3,
    col1: "Data 11",
    col2: "Data 12",
    col3: "Data 13",
    col4: "Data 14",
    col5: "Data 15",
  },
  {
    id: 4,
    col1: "Data 16",
    col2: "Data 17",
    col3: "Data 18",
    col4: "Data 19",
    col5: "Data 20",
  },
];
